const sideliteOptions = [
  { id: 1, type: "sideLite", label: "None" },
  { id: 2, type: "sideLite", label: "Single Sidelite" },
  { id: 3, type: "sideLite", label: "Double Sidelite" },
];

export { sideliteOptions };
